export default __webpack_public_path__ + "static/media/Nainital_3.98ca2749.jpg";